@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId">{{ label() }}</label>
  <lib-dropdown-input
    [formControl]="inputFormControl()"
    [clearable]="clearable()"
    [placeholder]="placeholder()"
    [dropdownItems]="dropdowns()"
    [controlId]="inputId"
    [error]="showError">
  </lib-dropdown-input>
  @if (hintText()) {
    <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
      {{ hintText() }}
    </div>
  }
  @if (showError) {
    <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
  }
</div>
